// extracted by mini-css-extract-plugin
export default {"keyboardContainer":"EmailCaptureView_keyboardContainer__irSvm"};